/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Health_Legacyunverified1Inputs */

const id_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum diverifikasi`)
};

const ms_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum disahkan`)
};

const da_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke bekræftet endnu`)
};

const de_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht verifiziert`)
};

const en_us2_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet verified`)
};

const es_es2_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún sin verificar`)
};

const es_mx2_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún sin verificar`)
};

const fil_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pa na-verify`)
};

const fr_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore vérifié`)
};

const it_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ancora verificata`)
};

const hu_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nincs ellenőrizve`)
};

const nl_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niet geverifieerd`)
};

const no_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke bekreftet ennå`)
};

const pl_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeszcze niezweryfikowany`)
};

const pt_br2_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não verificado`)
};

const pt_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não verificada`)
};

const ro_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neverificat încă`)
};

const fi_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä vahvistettu`)
};

const sv_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte verifierad ännu`)
};

const vi_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa được xác minh`)
};

const tr_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz doğrulanmadı`)
};

const cs_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosud neověřený`)
};

const bg_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все още непроверена`)
};

const ru_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ещё не проверен`)
};

const uk_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ще не перевірено`)
};

const ar_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم التحقق بعد`)
};

const hi_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी सत्यापित नहीं`)
};

const th_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้ยืนยัน`)
};

const ja_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未検証`)
};

const zh_cn2_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未验证`)
};

const zh_hant1_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未驗證`)
};

const ko_builds_health_legacyunverified1 = /** @type {(inputs: Builds_Health_Legacyunverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 검증되지 않음`)
};

/**
* | output |
* | --- |
* | "Not yet verified" |
*
* @param {Builds_Health_Legacyunverified1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_health_legacyunverified1 = /** @type {((inputs?: Builds_Health_Legacyunverified1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Health_Legacyunverified1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_health_legacyunverified1(inputs)
	if (locale === "ms") return ms_builds_health_legacyunverified1(inputs)
	if (locale === "da") return da_builds_health_legacyunverified1(inputs)
	if (locale === "de") return de_builds_health_legacyunverified1(inputs)
	if (locale === "en-US") return en_us2_builds_health_legacyunverified1(inputs)
	if (locale === "es-ES") return es_es2_builds_health_legacyunverified1(inputs)
	if (locale === "es-MX") return es_mx2_builds_health_legacyunverified1(inputs)
	if (locale === "fil") return fil_builds_health_legacyunverified1(inputs)
	if (locale === "fr") return fr_builds_health_legacyunverified1(inputs)
	if (locale === "it") return it_builds_health_legacyunverified1(inputs)
	if (locale === "hu") return hu_builds_health_legacyunverified1(inputs)
	if (locale === "nl") return nl_builds_health_legacyunverified1(inputs)
	if (locale === "no") return no_builds_health_legacyunverified1(inputs)
	if (locale === "pl") return pl_builds_health_legacyunverified1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_health_legacyunverified1(inputs)
	if (locale === "pt") return pt_builds_health_legacyunverified1(inputs)
	if (locale === "ro") return ro_builds_health_legacyunverified1(inputs)
	if (locale === "fi") return fi_builds_health_legacyunverified1(inputs)
	if (locale === "sv") return sv_builds_health_legacyunverified1(inputs)
	if (locale === "vi") return vi_builds_health_legacyunverified1(inputs)
	if (locale === "tr") return tr_builds_health_legacyunverified1(inputs)
	if (locale === "cs") return cs_builds_health_legacyunverified1(inputs)
	if (locale === "bg") return bg_builds_health_legacyunverified1(inputs)
	if (locale === "ru") return ru_builds_health_legacyunverified1(inputs)
	if (locale === "uk") return uk_builds_health_legacyunverified1(inputs)
	if (locale === "ar") return ar_builds_health_legacyunverified1(inputs)
	if (locale === "hi") return hi_builds_health_legacyunverified1(inputs)
	if (locale === "th") return th_builds_health_legacyunverified1(inputs)
	if (locale === "ja") return ja_builds_health_legacyunverified1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_health_legacyunverified1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_health_legacyunverified1(inputs)
	return ko_builds_health_legacyunverified1(inputs)
});
export { builds_health_legacyunverified1 as "builds.health.legacyUnverified" }